export default "__VITE_ASSET__CJokUZUU__"